import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})
export class JwtService {
    private platformId = inject(PLATFORM_ID);

    
    getToken(): string | null {
        if (isPlatformBrowser(this.platformId)) {
            return localStorage.getItem('token');
        }
        return null;
    }

    decodeToken(): any {
        const token = this.getToken();
        if (token) {
            try {
                return jwtDecode(token);
            } catch (error) {
                console.error('Error decoding token:', error);
                return null;
            }
        }
        return null;
    }

    getUserId(): string {
        const decoded = this.decodeToken();
        return decoded?.sub ?? null; // Adjust based on your token's structure
    }
}